import axios from 'axios';
import { loadAbort } from '../utilities';
import { Platform } from '@/enums/Platform.enum';

const route = import.meta.env.VITE_API_URL + 'coach';
const usersURL = import.meta.env.VITE_API_URL;

export const post = (data) => {
  const controller = loadAbort();
  return {
    call: () => axios.post(route, { ...data }, { signal: controller.signal }),
    controller,
  };
};

export const getUser = (id) => {
  const controller = loadAbort();

  return {
    call: () =>
      axios.get(`${usersURL}/userRol/${id}`, {
        signal: controller.signal,
      }),
    controller,
  };
};

export const CoacheeByCoacheeState = (id: string, state: string) => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.get(`${route}/ByCoacheeState/${state}/${id}`, {
        signal: controller.signal,
      }),
    controller,
  };
};

export const getAll = (page: number = 1, pageSize: number = 10) => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.get(`${route}/GetAllDashboard?page=${page}&pageSize=${pageSize}`, {
        signal: controller.signal,
      }),
    controller,
  };
};

export const googleAuth = (page: number = 1, pageSize: number = 10) => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.get(`${route}/GoogleAuth`, {
        signal: controller.signal,
      }),
    controller,
  };
};

export const GetAllCoachs = () => {
  const controller = loadAbort();
  return {
    call: () => axios.get(`${route}/GetAllCoachs`, { signal: controller.signal }),
    controller,
  };
};

export const getAllWithFilters = (page: number = 1, pageSize: number = 10, text: any) => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.patch(
        `${route}/GetAllDashboardWithFilters?page=${page}&pageSize=${pageSize}&searchQuery=${text}`,
        null,
        { signal: controller.signal },
      ),
    controller,
  };
};

export const getAllWithFilters2 = (page: number = 1, pageSize: number = 10, text: any) => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.patch(
        `${route}/GetAllDashboardWithFilters?page=${page}&pageSize=${pageSize}&searchQuery=${text}`,
        null,
        { signal: controller.signal },
      ),
    controller,
  };
};

export const CoacheeBySessionDate = (id: string, since: string) => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.get(`${route}/BySessionDate/${since}/${id}`, {
        signal: controller.signal,
      }),
    controller,
  };
};

export const getById = (id: string) => {
  const controller = loadAbort();
  return {
    call: () => axios.get(`${route}/${id}`, { signal: controller.signal }),
    controller,
  };
};

export const getCoachById = (id: string) => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.get(`${import.meta.env.VITE_API_URL + 'coach'}/${id}`, {
        signal: controller.signal,
      }),
    controller,
  };
};

export const getByCoachId = (id: string) => {
  const controller = loadAbort();
  return {
    call: () => axios.get(`${route}/${id}`, { signal: controller.signal }),
    controller,
  };
};

export const remove = (id) => {
  const controller = loadAbort();
  return {
    call: () => axios.delete(`${route}/${id}`, { signal: controller.signal }),
    controller,
  };
};

export const put = (id, data, appId = Platform.coaching) => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.put(
        `${route}/${id}`,
        { ...data },
        { signal: controller.signal, headers: { 'x-app-id': appId } },
      ),
    controller,
  };
};

/* export const getUnifiedCoaches = (params, appId) => {
  const controller = loadAbort();

  return {
    call: () =>
      axios.post(`${route}/unified`, params, {
        signal: controller.signal,
        headers: { 'x-app-id': appId },
      }),
    controller,
  };
}; */

export const refreshToken = ({ code }) => {
  const controller = loadAbort();
  return {
    call: () => axios.put(`${route}/RefreshToken`, { code }, { signal: controller.signal }),
    controller,
  };
};

export const updateCoachee = (id, data) => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.put(`${route}/UpdateCoachee/${id}`, { ...data }, { signal: controller.signal }),
    controller,
  };
};

export const removeCoachee = (id, data) => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.put(`${route}/RemoveCoachee/${id}`, { ...data }, { signal: controller.signal }),
    controller,
  };
};

export const getActiveCoaches = (page: number = 1, pageSize: number = 10) => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.get(`${route}/GetActiveCoaches?page=${page}&pageSize=${pageSize}`, {
        signal: controller.signal,
      }),
    controller,
  };
};

export const getUnActiveCoaches = (page: number = 1, pageSize: number = 10) => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.get(`${route}/GetUnActiveCoaches?page=${page}&pageSize=${pageSize}`, {
        signal: controller.signal,
      }),
    controller,
  };
};

export const getAlphabeticalCoaches = (
  page: number = 1,
  pageSize: number = 10,
  alphabeticalOrder,
) => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.get(
        `${route}/getAlphabeticalCoaches?page=${page}&pageSize=${pageSize}&alphabeticalOrder=${alphabeticalOrder}`,
        { signal: controller.signal },
      ),
    controller,
  };
};

export const getSearchWithFilters = (page: number = 1, pageSize: number = 10, filters: any) => {
  const controller = loadAbort();

  const params = new URLSearchParams({
    page: page.toString(),
    pageSize: pageSize.toString(),
  });

  if (filters?.statusUser !== undefined) {
    params.append('statusUser', filters.statusUser.toString());
  }

  if (filters?.languages && filters.languages.length > 0) {
    params.append('languages', filters.languages.join(','));
  }

  if (filters?.alphabeticalOrder !== undefined) {
    params.append('alphabeticalOrder', filters?.alphabeticalOrder?.toString());
  }

  const queryString = params.toString();

  return {
    call: () =>
      axios.get(`${route}/getSearchWithFilters?${queryString}`, {
        signal: controller.signal,
      }),
    controller,
  };
};

export const getUnifiedCoaches = (params, appId) => {
  const controller = loadAbort();

  return {
    call: () =>
      axios.post(`${route}/unified`, params, {
        signal: controller.signal,
        headers: { 'x-app-id': appId },
      }),
    controller,
  };
};

const nexusRoute = import.meta.env.VITE_APP_NEXUS_URL;

export const getUnifiedCoachesNexus = (params, appId = 'coaching') => {
  const controller = loadAbort();
  const { profileRole: _removed, ...body } = params;
  return {
    call: () =>
      axios.post(`${nexusRoute}/profiles/unified/coach`, body, {
        signal: controller.signal,
        headers: { 'x-app-id': appId },
      }),
    controller,
  };
};

export const patchProfileStatusNexus = (
  id: string,
  body: { status: string },
  appId = 'coaching',
) => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.patch(`${nexusRoute}/profiles/${id}`, body, {
        signal: controller.signal,
        headers: { 'x-app-id': appId },
      }),
    controller,
  };
};

export const getCoachByIdNexus = (id: string, appId = 'coaching') => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.get(`${nexusRoute}/profiles/coach/${id}`, {
        signal: controller.signal,
        headers: { 'x-app-id': appId },
      }),
    controller,
  };
};

export const updateCoachNexus = (id: string, body: Record<string, unknown>, appId = 'coaching') => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.patch(`${nexusRoute}/profiles/${id}`, body, {
        signal: controller.signal,
        headers: { 'x-app-id': appId },
      }),
    controller,
  };
};

export const createCoachNexus = (body: Record<string, unknown>, appId = 'coaching') => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.post(`${nexusRoute}/profiles/coach`, body, {
        signal: controller.signal,
        headers: { 'x-app-id': appId },
      }),
    controller,
  };
};

export const deleteCoachDashboard = (id: string, appId: string = 'coaching') => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.delete(`${route}/deleteCoachDashboard/${id}`, {
        signal: controller.signal,
        headers: { 'x-app-id': appId },
      }),
  };
};

export const resetCoachOnboarding = (id: string, appId: string = 'coaching') => {
  const controller = loadAbort();
  return {
    call: () =>
      axios.get(`${route}/resetOnboarding/${id}`, {
        signal: controller.signal,
        headers: { 'x-app-id': appId },
      }),
    controller,
  };
};

export default {
  post,
  remove,
  put,
};
